module.exports = __webpack_public_path__ + "img/83083428005808.38902c5f.png";